export default __webpack_public_path__ + "static/media/dark5.8bb0a925.png";